import React from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import {
  FormHeader,
  FormTitle,
  ClinicLogoContainer,
  ClinicLogo,
  InputsContainer,
  ButtonsContainer,
  FormContainer,
  FormSubtitleBold
} from '../../ui/form'
import Input from '../../ui/input'
import { Button } from '../../ui/button'
import ClinicaSantaIsabel from '../../../assets/images/clinics/ClinicaSantaIsabel.svg'
import ClinicaBazterrica from '../../../assets/images/clinics/ClinicaBazterrica.svg'
import ClinicaDelSol from '../../../assets/images/clinics/ClinicaDelSol.svg'
import CentroMedicoBazterica from '../../../assets/images/clinics/CentroMedicoBazterica.svg'
import CentroMedicoSantaRita from '../../../assets/images/clinics/CentroMedicoSantaRita.svg'
import Select from '../../ui/select'
import Autocomplete from '../../ui/autoComplete'

const initialValues = {
  docType: '',
  docNum: '',
  healthInsurance: '',
  healthPlan: '',
  credential: '',
  email: ''
}

const validationSchema = Yup.object().shape({
  docType: Yup.string().required('Campo requerido'),
  docNum: Yup.string().required('Campo requerido'),
  healthInsurance: Yup.string().required('Campo requerido'),
  healthPlan: Yup.string().required('Campo requerido'),
  credential: Yup.string().required('Campo requerido'),
  email: Yup.string()
    .email('Formato de email inválido')
    .required('Campo requerido')
})

const LoginForm = ({
  docTypes = [],
  plans = [],
  healthInsurances = [],
  handleSubmit,
  onHealthInsuranceChange
}) => {
  const documentTypes = docTypes.map(doc => ({
    value: doc.id,
    label: doc.name
  }))
  const healthInsuranceOptions = healthInsurances.map(opt => ({
    value: opt.id,
    label: opt.name
  }))

  const plansOptions = plans.map(plan => ({
    value: plan.id,
    label: plan.name
  }))

  return (
    <FormContainer paddingMobile="0px 15px" margin={"auto auto 0 auto"}>
      <FormHeader align="center" gap={16} mb={32}>
        <FormSubtitleBold>Te damos la bienvenida a</FormSubtitleBold>
        <FormTitle>Guardia Smart</FormTitle>
        <ClinicLogoContainer gap={8}>
          <ClinicLogo src={ClinicaSantaIsabel} alt="Clínica Santa Isabel" />
          <ClinicLogo src={ClinicaDelSol} alt="Clínica del Sol" />
          <ClinicLogo src={ClinicaBazterrica} alt="Clínica Bazterrica" />
          <ClinicLogo src={CentroMedicoBazterica} alt="Centro Médico Bazterrica" />
          <ClinicLogo src={CentroMedicoSantaRita} alt="Centro Médico Santa Rita" />
        </ClinicLogoContainer>
      </FormHeader>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <InputsContainer gap={16} mb={32}>
              <Select
                label="Tipo de documento"
                name="docType"
                value={values.docType}
                onChange={handleChange}
                onBlur={handleBlur}
                options={documentTypes}
                placeholder="Seleccioná el tipo de documento"
                error={touched.docType && errors.docType}
              />
              <Input
                label="Documento"
                name="docNum"
                placeholder="Ingresá tu número de documento"
                value={values.docNum}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.docNum && errors.docNum}
              />
              <Autocomplete
                label="Obra social o Prepaga"
                name="healthInsurance"
                value={values.healthInsurance}
                onChange={handleChange}
                options={healthInsuranceOptions}
                placeholder="Escribí tu obra social o prepaga"
                error={touched.healthInsurance && errors.healthInsurance}
                assignFieldValue={value => {
                  onHealthInsuranceChange(value)
                }}
              />

              {plansOptions.length > 0 && (
                <Select
                  label="Plan"
                  name="healthPlan"
                  value={values.healthPlan}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  options={plansOptions}
                  placeholder="Seleccioná tu plan"
                  error={touched.healthPlan && errors.healthPlan}
                />
              )}

              <Input
                label="Número de credencial"
                name="credential"
                placeholder="Ingresá tu número de credencial"
                value={values.credential}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.credential && errors.credential}
              />
              <Input
                label="Email"
                name="email"
                placeholder="Ingresá tu email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.email && errors.email}
              />

              <ButtonsContainer gap={24}>
                <Button
                  label="Ingresar"
                  $variant="primary"
                  size="mobile"
                  onClick={handleSubmit}
                  disabled={
                    !values.email ||
                    !values.docNum ||
                    !values.healthInsurance ||
                    !values.credential ||
                    !values.docType ||
                    !values.healthPlan
                  }
                />
              </ButtonsContainer>
            </InputsContainer>
          </Form>
        )}
      </Formik>
    </FormContainer>
  )
}

export default LoginForm
